/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Writing_Mode_TitleInputs */



/**
* | output |
* | --- |
* | "Toggle Writing Mode (Vertical/Horizontal)" |
*
* @param {Writing_Mode_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const writing_mode_title = /** @type {((inputs?: Writing_Mode_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Writing_Mode_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le Mode d'Ecriture (Vertical/Horizontal)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreibmodus umschalten (Vertikal/Horizontal)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la modalità di scrittura (verticale/orizzontale)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключение режима письма (вертикальный/горизонтальный)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar modo de escritura (vertical/horizontal)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换书写模式（垂直/水平）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書き込みモードを切り替える（縦書き/横書き）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लेखन मोड बदलें (ऊर्ध्वाधर/क्षैतिज)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar modo de escrita (vertical/horizontal)")
	return /** @type {LocalizedString} */ ("Toggle Writing Mode (Vertical/Horizontal)")
});